var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1 19v-1.5h7.178q1.564 0 2.694-1.034t1.129-2.552q0-1.52-1.13-2.549-1.128-1.029-2.693-1.029H7.257l2.782 2.783-1.054 1.054L4.4 9.586 8.985 5l1.054 1.054-2.782 2.782h7.02q2.195 0 3.76 1.465 1.564 1.464 1.564 3.613 0 2.147-1.565 3.617T14.278 19z"
  })));
};
export default SvgUndo;